export default "__VITE_ASSET__BjrixF$H__"